/**
 * Session and authentication configuration
 */

export const SESSION_CONFIG = {
  // Auto-logout after 30 minutes of inactivity
  INACTIVITY_TIMEOUT: 30 * 60 * 1000, // 30 minutes in milliseconds
  
  // Buffer time before token expiration to proactively refresh
  TOKEN_EXPIRY_BUFFER: 60 * 1000, // 1 minute in milliseconds
  
  // How often to check session validity
  SESSION_CHECK_INTERVAL: 60 * 1000, // 1 minute in milliseconds
  
  // Throttle activity tracking to avoid excessive updates
  ACTIVITY_THROTTLE: 5000, // 5 seconds
  
  // Access token expiry (backend setting, reflected here for reference)
  ACCESS_TOKEN_EXPIRY: '15m',
  
  // Refresh token expiry (backend setting, reflected here for reference)
  REFRESH_TOKEN_EXPIRY: '7d',
  
  // Whether to clear session when browser/tab closes
  LOGOUT_ON_WINDOW_CLOSE: false, // Set to true for more strict security
};

export default SESSION_CONFIG;

// Make it a module
export {};
